// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#normal-layout .site-content,
#normal-layout .header-content {
  margin-left: auto;
  margin-right: auto;
  max-width: 1600px;
  width: calc(100% - 180px);
}

#normal-layout .site-content {
  padding-top: 80px;
  padding-bottom: 10px;
}

/* Sidemenu start */

#side-menu {
  position: fixed;
  top: 120px;
  right: 0px;
  width: 80px !important;
  height: auto;
  padding-bottom: 10px;
  border-top-left-radius: 0.28571429rem;
  border-bottom-left-radius: 0.28571429rem;
  background-color: #1b1c1d;
  z-index: 1000;
}

#side-menu .navigation .menu {
  height: auto !important;
  display: block !important;
  width: inherit;
}

#side-menu .navigation .item {
  padding: 0.92857143em 0.34285714em !important;
}

#side-menu .navigation .item > .label {
  position: absolute;
  top: 7px;
  right: 7px;
  font-size: 0.64285714rem;
}

#side-menu .ui.divider {
  margin-top: 0px;
}

#side-menu .icon-panel .touch-icons {
  text-align: center;
  margin-top: 10px;
}

/*#side-menu .icon-panel .touch-icons > div.icon {
  margin: 10px 8px;
}

#side-menu .icon-panel .touch-icons > i.icon {
  padding: 10px 8px;
}*/

/* Allows up to 3 touch icons to be displayed */
#side-menu .icon-panel .touch-icons > .icon {
  margin: 0px 2px !important;
}

#side-menu .icon-panel .ui.progress:last-child {
  margin: 0px !important;
}

#side-menu .icon-panel .statistics-icons {
  margin-left: 10px;
  margin-right: auto;
  font-size: 9.5px !important;
}

/* Sidemenu end */
`, "",{"version":3,"sources":["webpack://./src/components/main/style.normal.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;EAME;;AAEF,+CAA+C;AAC/C;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,iBAAiB","sourcesContent":["#normal-layout .site-content,\r\n#normal-layout .header-content {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  max-width: 1600px;\r\n  width: calc(100% - 180px);\r\n}\r\n\r\n#normal-layout .site-content {\r\n  padding-top: 80px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n/* Sidemenu start */\r\n\r\n#side-menu {\r\n  position: fixed;\r\n  top: 120px;\r\n  right: 0px;\r\n  width: 80px !important;\r\n  height: auto;\r\n  padding-bottom: 10px;\r\n  border-top-left-radius: 0.28571429rem;\r\n  border-bottom-left-radius: 0.28571429rem;\r\n  background-color: #1b1c1d;\r\n  z-index: 1000;\r\n}\r\n\r\n#side-menu .navigation .menu {\r\n  height: auto !important;\r\n  display: block !important;\r\n  width: inherit;\r\n}\r\n\r\n#side-menu .navigation .item {\r\n  padding: 0.92857143em 0.34285714em !important;\r\n}\r\n\r\n#side-menu .navigation .item > .label {\r\n  position: absolute;\r\n  top: 7px;\r\n  right: 7px;\r\n  font-size: 0.64285714rem;\r\n}\r\n\r\n#side-menu .ui.divider {\r\n  margin-top: 0px;\r\n}\r\n\r\n#side-menu .icon-panel .touch-icons {\r\n  text-align: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n/*#side-menu .icon-panel .touch-icons > div.icon {\r\n  margin: 10px 8px;\r\n}\r\n\r\n#side-menu .icon-panel .touch-icons > i.icon {\r\n  padding: 10px 8px;\r\n}*/\r\n\r\n/* Allows up to 3 touch icons to be displayed */\r\n#side-menu .icon-panel .touch-icons > .icon {\r\n  margin: 0px 2px !important;\r\n}\r\n\r\n#side-menu .icon-panel .ui.progress:last-child {\r\n  margin: 0px !important;\r\n}\r\n\r\n#side-menu .icon-panel .statistics-icons {\r\n  margin-left: 10px;\r\n  margin-right: auto;\r\n  font-size: 9.5px !important;\r\n}\r\n\r\n/* Sidemenu end */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
